import { render, staticRenderFns } from "./BaseTextarea.vue?vue&type=template&id=cd5bae36&"
import script from "./BaseTextarea.vue?vue&type=script&lang=js&"
export * from "./BaseTextarea.vue?vue&type=script&lang=js&"
import style0 from "./BaseTextarea.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../GbR/10__Projekte/2021-04-26__Cumulus-Metadaten-Generator/03  App/v1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports